
export const LIST_LEAD = 'LIST_LEAD'
export const LIST_LEAD_PENDING = `${LIST_LEAD}_PENDING`
export const LIST_LEAD_FULFILLED = `${LIST_LEAD}_FULFILLED`
export const LIST_LEAD_REJECTED = `${LIST_LEAD}_REJECTED`

export const LIST_TASK = 'LIST_TASK'
export const LIST_TASK_PENDING = `${LIST_TASK}_PENDING`
export const LIST_TASK_FULFILLED = `${LIST_TASK}_FULFILLED`
export const LIST_TASK_REJECTED = `${LIST_TASK}_REJECTED`



// WEBPACK FOOTER //
// ./src/lead/LeadConstants.js